





import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class BhFlowDroppable extends Vue {
    @Prop({ default: false })
    horizontal!: boolean

    over = false;

    public onDrop(data: any, e: any) {
        this.over = false;
        this.$emit('drop', {
            data,
            event: e
        });
    }

}
